module.exports = __webpack_public_path__ + "media/dice_role.b6ca72f1.mp3";